/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { DebounceTime, type HostedObserverConfig } from '@adp-studio/autosave';

import { type BotSkillStore } from '@/store/bot-skill';
import { ItemTypeExtra } from '@/save-manager/types';

type RegisterImageGeneration = HostedObserverConfig<
  BotSkillStore,
  ItemTypeExtra,
  string[]
>;

export const imageGenerationConfig: RegisterImageGeneration = {
  key: ItemTypeExtra.ImageGeneration,
  selector: store => store.imageGenerationModelIds,
  debounce: DebounceTime.Immediate,
  middleware: {
    onBeforeSave: modelIds => ({
      image_generation_config: { model_ids: modelIds },
    }),
  },
};
